import classNames from "classnames";
import React from "react";
import SolanaIcon from "../../icons/activity/Solana.svg";

export const SolanaCoinIcon = ({
  size = "2.5rem",
  className,
}: {
  size?: string | number;
  className?: string;
}) => {
  return (
    <div
      className={classNames("coin-icon", className)}
      style={{ width: size, height: size }}
    >
      <SolanaIcon />

      <style jsx>{`
        .coin-icon {
          background-color: var(--tertiary-bg-color);
          overflow: hidden;
          border-radius: 50%;

          :global(svg) {
            display: block;
            width: 100%;
            height: 100%;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: cover;
          }
        }
      `}</style>
    </div>
  );
};
